import { CSSProperties } from 'react';
import Box from '@mui/material/Box';
import SSRIcon from '@ingka/ssr-icon/SSRIcon';
import { IconEntry, IconType } from '../types';
import iconMapping from '../icons';

type IconComponentProps = {
  icon: keyof typeof iconMapping;
  style?: CSSProperties;
};

export const IconComponent = ({ icon, style }: IconComponentProps) => {
  const iconEntry: IconEntry = iconMapping[icon];

  const defaultStyles: CSSProperties = {
    width: 24,
    height: 24,
    color: iconEntry?.color ?? '#000000',
  };

  const combinedStyles = { ...defaultStyles, ...style };

  switch (iconEntry?.type) {
    case IconType.MUI:
      return <Box component={iconEntry.component} sx={combinedStyles} />;

    case IconType.SSR:
      return <SSRIcon paths={iconEntry.component} style={combinedStyles} />;

    default:
      return (
        <SSRIcon
          style={combinedStyles}
          paths={iconMapping.imageStrikethrough.component}
        />
      );
  }
};
